import { inject } from '@angular/core';

import { SecurityService } from '@connect-services/client/services/security.service';
import { SnackBarService } from '@shared/client/services/snack-bar.service';

export function authenticatedGuard(): Promise<boolean> | boolean {
    const securityService = inject(SecurityService);
    const snackBarService = inject(SnackBarService);

    if (!securityService.isAuthenticated()) {
        snackBarService.openErrorSnackBar('sessionExpiredError');

        return securityService.logout();
    }

    return true;
}
